// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"a049a495754deac2856f","966":"fc1803165034f0fa22f7"}[chunkId] + ".js";
};